import * as Yup from 'yup';
import { Model } from './Model';

export interface DesignType {
    id: number;
    name: string;
    description: string;
    category_id: number;
    category: any;
    image_id: number;
    image: any;
}

export const Design = Model<DesignType>('Design', {
    endpoint: 'apparel-design',
})`
    id:Int;
    name:String;
    description:String;
    category_id:Int;
    category:Any;
    image_id:Int;
    image:Any;
`;

export const DesignValidation = Yup.object({
    name: Yup.string().required(),
});
